import {
  TolMessagesActions,
  TolMessagesMutations,
  TolMessagesGetters
} from '@/app/features/tol-messages/tol-messages.keys';

export const getInitialState = () => {
  return {
    messages: {},
    keepOnce: false
  };
};
export const messagesStore = {
  state: getInitialState(),
  getters: {
    [TolMessagesGetters.HasMessages]: state => {
      return Object.keys(state.messages).length > 0;
    },
    [TolMessagesGetters.Messages]: state => state.messages,
    [TolMessagesGetters.KeepOnce]: state => state.keepOnce
  },
  actions: {
    [TolMessagesActions.SetMessages]: ({ commit }, messages) => {
      commit(TolMessagesMutations.SetMessages, messages);
      window.setTimeout(() => {
        commit(TolMessagesMutations.ResetMessagesState);
      }, 4000);
    },
    [TolMessagesActions.ClearAll]: ({ commit }) => {
      commit(TolMessagesMutations.ResetMessagesState);
    },
    [TolMessagesActions.ClearAll]: ({ commit }) => {
      commit(TolMessagesMutations.ResetMessagesState);
    },
    [TolMessagesActions.RemoveMessage]: ({ commit }, idx) => {
      commit(TolMessagesMutations.RemoveMessage, idx);
    }
  },
  mutations: {
    [TolMessagesMutations.SetMessages]: (state, messages) => {
      state.messages = messages;
    },
    [TolMessagesMutations.ResetMessagesState]: state => {
      Object.assign(state, getInitialState());
    },
    [TolMessagesMutations.RemoveMessage]: (state, idx) => {
      state.messages.splice(idx, 1);
    }
  }
};
